const riot = require('riot');

riot.tag2('atom-input-select', '<div class="relative w-full"> <select class="select w-full lh14 cursor-pointer {!!getValue() ? &quot;text-navy&quot; : &quot;text-gray_30&quot;}" ref="select" name="{opts.name || opts.ref}" disabled="{hasKeyOfNotFalse(&quot;disabled&quot;)}" required="{hasKeyOfNotFalse(&quot;required&quot;)}" readonly="{hasKeyOfNotFalse(&quot;readonly&quot;)}" onchange="{_.noop}"> <option value="" selected style="display:none">{opts.placeholder}</option> <option each="{option in opts.options}" riot-value="{option.id}" selected="{option.id === opts.riotValue}">{option.name || option.label}</option> </select> <div class="absolute r12 t0 b0 f fh pointer-none"><i class="icon-cheveron-down fs24 text-navy_30"> </i></div> </div>', '', '', function(opts) {
    this.getValue = () => {
      return this.refs.select.value;
    };

    this.setValue = (value) => {
      this.refs.select.value = value;
      this.update();
    };

    this.hasKeyOfNotFalse = (key) => {
      return key in this.opts && this.opts[key] !== false;
    };
});